export const filmsData = [
  {
    title: 'Farzi',
    platform: 'Amazon Prime Video',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/j7417c3z_WhatsApp%20Image%202026-04-08%20at%201.38.06%20PM.jpeg',
    duration: '8 Episodes',
    releaseDate: '2023',
    genre: 'Thriller',
    role: 'Assistant Director — Neha Kshatriya',
    link: 'https://youtu.be/rcQ_xZdzPBc?si=9H_7AxzCCNxNof09',
  },
  {
    title: 'Ubarro',
    platform: 'Gujarati Film',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/ewfvc21u_84cf1c11-ab6d-4020-a4cc-ed0657f4b72d.jpg',
    releaseDate: '2025',
    genre: 'Drama',
    role: 'Post Release Advisory — Pratik Choksi',
    link: 'https://youtu.be/SDXOE7kk6pE?si=-Jmxqul5o37EQEsM',
  },
  {
    title: 'Hurry Om Hurry',
    platform: 'Gujarati Film',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/ggk6w3bl_WhatsApp%20Image%202026-04-08%20at%201.41.34%20PM.jpeg',
    releaseDate: '2023',
    genre: 'Drama',
    role: 'Post Release Advisory — Pratik Choksi',
    link: 'https://youtu.be/QoiqXCf-kiA?si=_H7TskymKrtk_PGM',
  },
  {
    title: 'Shu Thayu?',
    platform: 'Gujarati Film',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/4dv3vgfj_WhatsApp%20Image%202026-04-09%20at%2012.22.29%20AM.jpeg',
    releaseDate: '2018',
    genre: 'Drama',
    role: 'Assistant Director — Neha Kshatriya\nExecutive Producer — Pratik Choksi',
    link: 'https://m.imdb.com/title/tt8831284/?ref_=ext_shr_lnk',
  },
  {
    title: 'Vandha Villas',
    platform: 'Gujarati Film',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/w7dtr844_251d395d-276b-4008-b229-e94d28572a59.jpg',
    releaseDate: '2018',
    genre: 'Drama',
    role: 'Assistant Director — Neha Kshatriya\nExecutive Producer — Pratik Choksi',
    link: 'https://m.imdb.com/title/tt8422610/?ref_=ext_shr_lnk',
  },
  {
    title: 'Ventilator',
    platform: 'Gujarati Film',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/rpbcivah_MV5BM2Y1NjExOTUtMmIxNC00ZDZhLWJiY2QtODYxMWJhNWQzZWY5XkEyXkFqcGc%40._V1_FMjpg_UX1000_.jpg',
    releaseDate: '2018',
    genre: 'Drama',
    role: 'Post Release Advisory — Pratik Choksi',
    link: 'https://youtu.be/zlnsxTuef98?si=6Xxxoa-r8CIZ1zdU',
  },
  {
    title: 'Karsandas Pay & Use',
    platform: 'Gujarati Film',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/0ylnf1ey_9692668b-1c44-4654-b689-7b0ecd55a82b.jpg',
    releaseDate: '2017',
    genre: 'Comedy',
    role: 'Executive Producer — Pratik Choksi',
    link: 'https://m.imdb.com/title/tt6771678/?ref_=ext_shr_lnk',
  },
  {
    title: 'Days of Tafree',
    platform: 'Gujarati Film',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/f0ldg9gq_4b2b5e9b-adc8-49ec-9871-0af4d279c884.jpg',
    releaseDate: '2016',
    genre: 'Comedy',
    role: 'Line Producer — Pratik Choksi',
    link: 'https://youtu.be/F2kUYPANFKs?si=Ps0mV3ZRUTLHEPnZ',
  },
  {
    title: 'Rang Jo Lagyo',
    platform: 'Coming Soon',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/ggoln5ii_WhatsApp%20Image%202026-04-08%20at%201.17_edited.jpg',
    comingSoon: true,
    role: 'First Assistant Director — Neha Kshatriya',
  },
  {
    title: 'Family Circus',
    platform: 'Gujarati Film',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/tubwor1u_WhatsApp%20Image%202026-04-09%20at%2012.32.27%20AM.jpeg',
    releaseDate: '2019',
    genre: 'Comedy',
    role: 'Promotions — Pratik Choksi',
    link: 'https://youtu.be/bjYqWq9sIZE?si=sr238Q9SvtM3D0nL',
  },
  {
    title: 'Suryansh',
    platform: 'Gujarati Film',
    poster: 'https://customer-assets.emergentagent.com/job_entertainment-gold/artifacts/svif1sy8_WhatsApp%20Image%202026-04-08%20at%2011.38.09%20AM.jpeg',
    releaseDate: '2018',
    genre: 'Drama',
    role: 'Promotions — Pratik Choksi',
    link: 'https://youtu.be/ro8x_DQbrGw?si=6lAqA-SshvwAQEUW',
  },
];
